import { redirect } from "@tanstack/react-router";
import type { FirstWinGateResult } from "./resolve-first-win-gate";

export function applyFirstWinGateRedirects(
  gate: FirstWinGateResult,
  isOnOnboardingPath: boolean,
  organizationId: string,
  projectId: string
): void {
  if (gate.kind === "redirect-to-onboarding" && !isOnOnboardingPath) {
    throw redirect({
      to: "/orgs/$organizationId/projects/$projectId/onboarding",
      params: { organizationId, projectId },
    });
  }

  if (gate.kind === "skip" && isOnOnboardingPath) {
    throw redirect({
      to: "/orgs/$organizationId/projects/$projectId/playground/chat",
      params: { organizationId, projectId },
    });
  }
}
